import { __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useState, useRef, useEffect } from 'react';
import { InputGroup, Input } from 'reactstrap';
import classNames from 'classnames';
import SvgSearch24 from '../../../icons/interface/Search24.js';

var TableSearch = function (_a) {
    var className = _a.className, _b = _a.debounce, debounce = _b === void 0 ? 0 : _b, _c = _a.placeholder, placeholder = _c === void 0 ? 'Search' : _c, _d = _a.initialValue, initialValue = _d === void 0 ? '' : _d, onChange = _a.onChange;
    var _e = useState(initialValue), value = _e[0], setValue = _e[1];
    var _f = useState(initialValue), lastSetValue = _f[0], setLastSetValue = _f[1];
    var debounceTimeoutRef = useRef(null);
    useEffect(function () {
        setValue(initialValue);
        setLastSetValue(initialValue);
    }, [initialValue]);
    useEffect(function () {
        if (lastSetValue === value)
            return;
        setLastSetValue(value);
        if (debounce > 0) {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
            // @ts-ignore atypical use of useRef to persist the ID returned by setTimeout across renders
            debounceTimeoutRef.current = setTimeout(function () {
                onChange(value);
            }, debounce);
            return function () {
                /* istanbul ignore else */
                if (debounceTimeoutRef.current) {
                    clearTimeout(debounceTimeoutRef.current);
                }
            };
        }
        else {
            onChange(value);
        }
    }, [value, debounce]);
    return (jsx("div", __assign({ className: classNames('d-inline-block', className) }, { children: jsxs(InputGroup, __assign({ className: "input-group-merge" }, { children: [jsx(Input, { className: "form-control-appended", value: value, onChange: function (e) { return setValue(e.target.value); }, placeholder: placeholder, "data-testid": "table-search-input" }), jsx("div", __assign({ className: "input-group-append" }, { children: jsx("div", __assign({ className: "input-group-text" }, { children: jsx(SvgSearch24, {}) })) }))] })) })));
};

export { TableSearch };
